import { render, staticRenderFns } from "./CrmMenu.vue?vue&type=template&id=9a0c03ac&scoped=true&"
import script from "./CrmMenu.vue?vue&type=script&lang=js&"
export * from "./CrmMenu.vue?vue&type=script&lang=js&"
import style0 from "./CrmMenu.vue?vue&type=style&index=0&id=9a0c03ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0c03ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
